import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";


import { AuthProvider, useAuth } from "./config/AuthContext";
import MainRoutes from "./routes/MainRoute";
import SessionGuard from "./components/SessionGuard";
import SessionExpiryNotice from "./components/SessionExpiryNotice";
import { registerDeployUpdateCheck } from "./utils/deployUpdateCheck";
import { applyRouteAwareDocumentTitle } from "./utils/tmsDocumentTitle";
import { installProtectedLinkGuard } from "./utility/protectedLinkGuard";

import "react-datepicker/dist/react-datepicker.css";
import "./App.css";
import { ErrorBoundaryWrapper } from "./components/ErrorBoundary";

/** Polls session heartbeat while logged in so kicked devices sign out. */
function AuthenticatedSessionGuard() {
    const { isAuthenticated } = useAuth();
    if (!isAuthenticated) return null;
    return <SessionGuard />;
}

/** Sync browser tab title to the current internal route (HBL, Address Book, etc.). */
function DocumentTitleSync() {
    const location = useLocation();
    useEffect(() => {
        applyRouteAwareDocumentTitle(location.pathname);
    }, [location.pathname]);
    return null;
}

function App() {
    useEffect(() => registerDeployUpdateCheck(), []);

    // Stop expired-session clicks before a protected page is opened/loaded.
    useEffect(() => installProtectedLinkGuard(), []);

    useEffect(() => {
        applyRouteAwareDocumentTitle(window.location.pathname);
    }, []);

    return (
        <AuthProvider>
            <ThemeProvider>
                <LanguageProvider>
                    <div className="App">
                        <BrowserRouter>
                            <DocumentTitleSync />
                            <AuthenticatedSessionGuard />
                            {/* <ErrorBoundaryWrapper> */}
                            <MainRoutes />
                            {/* </ErrorBoundaryWrapper> */}
                            <SessionExpiryNotice />
                        </BrowserRouter>
                        <Toaster position="top-right" richColors />
                    </div>
                </LanguageProvider>
            </ThemeProvider>
        </AuthProvider>
    );
}

export default App;